import { render, staticRenderFns } from "./ThePaymentTable.vue?vue&type=template&id=1c298f0f&scoped=true"
import script from "./ThePaymentTable.vue?vue&type=script&lang=js"
export * from "./ThePaymentTable.vue?vue&type=script&lang=js"
import style0 from "./ThePaymentTable.vue?vue&type=style&index=0&id=1c298f0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c298f0f",
  null
  
)

export default component.exports